/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import jwtDecode from "jwt-decode"
import { datadogRum } from "@datadog/browser-rum"
import { sessionInfo } from "./session"
import { storageHelper } from "./storage"

export const logout = (): void => {
  storageHelper.clearStoreSearchHistory()
}

export const getUserCityID = (): number => {
  const userProfile = storageHelper.getUserProfile()
  return userProfile?.city_id || 0
}

export const isAuthenticated = (): boolean => {
  const token = storageHelper.getToken()
  const isAuthWithCookie = storageHelper.isCookieAuthEnabled()
  const userProfile = storageHelper.getUserProfile()
  // Special handling for weblogin login case, since for this flow we won't have
  // any JWT being saved inside the localStorage, and return early.
  if (isAuthWithCookie && !!userProfile?.user_profile?.username) {
    return true
  }
  if (!token) {
    return false
  }
  try {
    const decodedToken = jwtDecode(token)
    if (!decodedToken.exp || decodedToken.exp < Date.now() / 1000) {
      logout()
      return false
    }
  } catch (err) {
    datadogRum.addError(err, {
      tags: { context: "Authentication" },
    })
    logout()
    return false
  }
  sessionInfo.jwt = token
  return true
}
